import { render, staticRenderFns } from "./add-auth.vue?vue&type=template&id=e55403b4&scoped=true"
import script from "./add-auth.vue?vue&type=script&lang=js"
export * from "./add-auth.vue?vue&type=script&lang=js"
import style0 from "./add-auth.vue?vue&type=style&index=0&id=e55403b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55403b4",
  null
  
)

export default component.exports